<template lang="pug">
portal(
  v-if="dialogId"
  :to="`${dialogId}.content`"
  v-slot="{ close }"
)
  .d-flex.flex-column.gap-16
    h2.mt-8 Мобильное приложение
    p.text-justify.body-2 Если вы здесь для участия в мероприятиях, рекомендуем (даже настаиваем) вам использовать специальное мобильное приложение «Афиша мероприятий»
    dv-btn.full-width(
      :href="appLink"
      x-large
    )
      p.body-2 Открыть приложение
    //- app-button.full-width.close-button.rounded-12.overflow-x-hidden(
    //-   height="auto"
    //-   :style-type="STYLE_TYPE.text"
    //-   @click="close"
    //- )
    //-   p.text-wrap.caption {{ !$user.isAuthenticated ? 'Я организатор и хочу именно с телефона работать на платформе' : 'Закрыть' }}
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  name: 'MobileDialog',
  components: {
    DvBtn,
  },
  props: {},
  data() {
    return {
      dialogId: undefined,
    };
  },
  computed: {
    appLink() {
      const { APPLICATION_APPLE, APPLICATION_RUSTORE } = this.$conf;
      if (/iPhone|iPad|iPod|Mac|iPad Simulator|iPhone Simulator|iPod Simulator/i.test(navigator.userAgent)) {
        return APPLICATION_APPLE;
      }
      return APPLICATION_RUSTORE;
    },
  },
  watch: {},
  mounted() {
    if (this.$conf.isMobile && (!this.$user.isAuthenticated || this.$user.isMember)) {
      /** Не подгружает контейнер диалогов сразу (не открывается диалог).
       * Не понимаю, в чём проблема, пытался через nextTick, та же история.
       * Если у кого-то хватит мозгов, как без костылей запустить
       * диалог, то извольте исправить эту несостоятельность ниже
       */
      setTimeout(() => this.openDialog(), 1000);
      // this.openDialog();
    }
  },
  methods: {
    openDialog() {
      this.dialogId = this.$dialogs.portal({
        attrs: {
          'max-width': 800,
          hideHeader: true,
          persistent: true,
          scrollable: false,
          hideActions: true,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.close-button {
  &::v-deep .v-btn__content {
    overflow-x: hidden;
    width: 100%;
  }
}
</style>
